import React from "react";
import {
  Col,
  Row,
  Form,
  Modal,
  Checkbox,
  Button,
  Input,
  InputNumber,
  Spin,
} from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import "./DownloadForm.css";
import GAText from "./GAText";

const DownloadForm = ({
  isSubmitting = false,
  submitDownloadForm = () => {},
  form = undefined,
  fName = "",
  fDesc = "",
}) => {
  const onFinish = (values) => {
    submitDownloadForm(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Spin spinning={isSubmitting}>
      <Form
        className="downloadForm"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row className="mb-3" gutter={16}>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  First Name
                </label>
              }
              required
              rules={[
                { required: true, message: "Please input your first name" },
              ]}
              name="firstName"
            >
              <Input type="text" placeholder="First Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Last Name
                </label>
              }
              required
              rules={[
                { required: true, message: "Please input your last name" },
              ]}
              name="lastName"
            >
              <Input type="text" placeholder="Last Name" />
            </Form.Item>
          </Col>
        </Row>

        <Row className="mb-3" gutter={16}>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Email
                </label>
              }
              required
              rules={[
                {
                  type: "email",
                  message: "Please make sure the email address is valid",
                },
                {
                  required: true,
                  message: "Please input your email address",
                },
              ]}
              name="email"
            >
              <Input type="email" placeholder="user@example.com" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item
              label={
                <label
                  className="text-primary-purple"
                  style={{ fontSize: "1rem" }}
                >
                  Phone (+1)
                </label>
              }
              required
              rules={[
                {
                  pattern: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/,
                  message: "Please check the format of phone number",
                },
                {
                  required: true,
                  message: "Please input your phone number",
                },
              ]}
              name="phone"
            >
              <Input type="text" placeholder="555-555-5555" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label={
            <label className="text-primary-purple" style={{ fontSize: "1rem" }}>
              Download {fDesc}
            </label>
          }
          rules={[
            { max: 300, message: "Message length cannot over 300 characters." },
          ]}
          name="message"
          className="mb-3"
        >
          <Input.TextArea rows={5} showCount maxLength={300} />
        </Form.Item>
        <GAText></GAText>
      </Form>
    </Spin>
  );
};

const DownloadModal = ({
  setting = {
    title: "Enter the following information to download",
    isModalVisible: false,
  },
  isSubmitting = false,
  handleCancel = () => {},
  submitForm = (values) => {
    console.log(values);
  },
  form = undefined,
}) => {
  return (
    <Modal
      title={setting.title}
      visible={setting.isModalVisible}
      onCancel={handleCancel}
      width={"80%"}
      onOk={form && form.submit}
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isSubmitting}
          disabled={isSubmitting}
          onClick={form && form.submit}
        >
          Request Download
        </Button>,
      ]}
    >
      <DownloadForm
        submitForm={submitForm}
        isSubmitting={isSubmitting}
        form={form}
      />
    </Modal>
  );
};

export { DownloadForm, DownloadModal };
